export default __webpack_public_path__ + "static/image4-30d08fd6df7ab689a4ede45e239ef667.jpg";